import { render, staticRenderFns } from "./TaskforcePerWeekTable.vue?vue&type=template&id=6263b7f6&"
import script from "./TaskforcePerWeekTable.vue?vue&type=script&lang=js&"
export * from "./TaskforcePerWeekTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports